export default "__VITE_ASSET__CWh0NguK__"